import {
  Popover,
  Box,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useDisclosure,
  PopoverCloseButton,
} from '@chakra-ui/react';
import { FilterTrigger } from './trigger';
import { FilterContent } from './content';
import { useRef } from 'react';
import type { FilterProps } from '.';
import { useKFlags } from '@/hooks/use-k-flags';

export const ReportFilter = ({
  filtersToShow,
  onSave,
  selected,
  onReset,
  triggerContent = 'Filters',
  isEditMode = false,
  reportType,
}: Pick<
  FilterProps,
  | 'selected'
  | 'filtersToShow'
  | 'onSave'
  | 'onReset'
  | 'triggerContent'
  | 'isEditMode'
  | 'reportType'
>) => {
  const ref = useRef();
  const { onClose, isOpen, onOpen } = useDisclosure();

  const { feReportsV3 } = useKFlags();

  const hasSelectedFilters = selected?.length > 0;
  const selectedCount = selected?.length ?? 0;
  const selectedItem = hasSelectedFilters
    ? selected?.[0]?.filter_by?.label
    : undefined;

  const getFilterLabel = () => {
    const prefix = isEditMode ? 'Default filters:' : 'Filtered by';
    if (!hasSelectedFilters || !selectedItem) return triggerContent;
    if (selectedCount === 1) return `${prefix} ${selectedItem}`;
    if (selectedCount === 2)
      return `${prefix}  ${selectedItem} and 1 other field`;
    return `${prefix}  ${selectedItem} and ${selectedCount - 1} other fields`;
  };

  const triggerText = feReportsV3 ? getFilterLabel() : triggerContent;

  return (
    <Box
      minWidth="100px"
      ref={ref}
      position="relative"
      sx={{
        '.chakra-popover__popper': {
          zIndex: 12,
        },
      }}
    >
      <Popover placement="bottom-start" isOpen={isOpen}>
        <PopoverTrigger>
          <FilterTrigger triggerText={triggerText} onClick={onOpen} />
        </PopoverTrigger>
        <PopoverContent w="850px" top="32px">
          <PopoverCloseButton
            onClick={onClose}
            _focus={{ boxShadow: 'none' }}
            top="22px"
            right="28px"
            stroke="currentColor"
          />
          <PopoverBody>
            <FilterContent
              filtersToShow={filtersToShow}
              selected={selected}
              onSave={(values) => {
                onSave(values);
                onClose();
              }}
              onReset={onReset}
              isEditMode={isEditMode}
              reportType={reportType}
              onClose={onClose}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
